import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-578bb8ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "workout-detail" }

import {
    ComputedRef,
    Ref,
    computed,
    ref,
    toRefs,
    watch,
    withDefaults,
  } from 'vue'
  import { useRoute } from 'vue-router'

  import WorkoutCardTitle from '@/components/Workout/WorkoutDetail/WorkoutCardTitle.vue'
  import WorkoutData from '@/components/Workout/WorkoutDetail/WorkoutData.vue'
  import WorkoutMap from '@/components/Workout/WorkoutDetail/WorkoutMap/index.vue'
  import { WORKOUTS_STORE } from '@/store/constants'
  import { ISport } from '@/types/sports'
  import { IUserProfile } from '@/types/user'
  import {
    IWorkout,
    IWorkoutData,
    IWorkoutObject,
    IWorkoutSegment,
    TCoordinates,
  } from '@/types/workouts'
  import { useStore } from '@/use/useStore'
  import { formatWorkoutDate, getDateWithTZ } from '@/utils/dates'

  interface Props {
    authUser: IUserProfile
    displaySegment: boolean
    sports: ISport[]
    workoutData: IWorkoutData
    markerCoordinates?: TCoordinates
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    authUser: null,
    displaySegment: { type: Boolean },
    sports: null,
    workoutData: null,
    markerCoordinates: { default: () => ({} as TCoordinates) }
  },
  setup(__props: any) {

const props = __props as { authUser: IUserProfile, displaySegment: boolean, sports: ISport[], workoutData: IWorkoutData, markerCoordinates: TCoordinates }

  

  const route = useRoute()
  const store = useStore()

  const { authUser, markerCoordinates, workoutData } = toRefs(props)
  const workout: ComputedRef<IWorkout> = computed(
    () => props.workoutData.workout
  )
  let segmentId: Ref<number | null> = ref(
    route.params.workoutId ? +route.params.segmentId : null
  )
  const segment: ComputedRef<IWorkoutSegment | null> = computed(() =>
    workout.value.segments.length > 0 && segmentId.value
      ? workout.value.segments[+segmentId.value - 1]
      : null
  )
  let displayModal: Ref<boolean> = ref(false)
  const sport = computed(() =>
    props.sports
      ? props.sports.find(
          (sport) => sport.id === props.workoutData.workout.sport_id
        )
      : {}
  )
  const workoutObject = computed(() =>
    getWorkoutObject(workout.value, segment.value)
  )

  function getWorkoutObjectUrl(
    workout: IWorkout,
    displaySegment: boolean,
    segmentId: number | null
  ): Record<string, string | null> {
    const previousUrl =
      displaySegment && segmentId && segmentId !== 1
        ? `/workouts/${workout.id}/segment/${segmentId - 1}`
        : !displaySegment && workout.previous_workout
        ? `/workouts/${workout.previous_workout}`
        : null
    const nextUrl =
      displaySegment && segmentId && segmentId < workout.segments.length
        ? `/workouts/${workout.id}/segment/${segmentId + 1}`
        : !displaySegment && workout.next_workout
        ? `/workouts/${workout.next_workout}`
        : null
    return {
      previousUrl,
      nextUrl,
    }
  }
  function getWorkoutObject(
    workout: IWorkout,
    segment: IWorkoutSegment | null
  ): IWorkoutObject {
    const urls = getWorkoutObjectUrl(
      workout,
      props.displaySegment,
      segmentId.value ? +segmentId.value : null
    )
    const workoutDate = formatWorkoutDate(
      getDateWithTZ(
        props.workoutData.workout.workout_date,
        props.authUser.timezone
      )
    )
    return {
      ascent: segment ? segment.ascent : workout.ascent,
      aveSpeed: segment ? segment.ave_speed : workout.ave_speed,
      distance: segment ? segment.distance : workout.distance,
      descent: segment ? segment.descent : workout.descent,
      duration: segment ? segment.duration : workout.duration,
      maxAlt: segment ? segment.max_alt : workout.max_alt,
      maxSpeed: segment ? segment.max_speed : workout.max_speed,
      minAlt: segment ? segment.min_alt : workout.min_alt,
      moving: segment ? segment.moving : workout.moving,
      nextUrl: urls.nextUrl,
      pauses: segment ? segment.pauses : workout.pauses,
      previousUrl: urls.previousUrl,
      records: segment ? [] : workout.records,
      segmentId: segment ? segment.segment_id : null,
      title: workout.title,
      type: props.displaySegment ? 'SEGMENT' : 'WORKOUT',
      workoutDate: workoutDate.workout_date,
      weatherEnd: segment ? null : workout.weather_end,
      weatherStart: segment ? null : workout.weather_start,
      with_gpx: workout.with_gpx,
      workoutId: workout.id,
      workoutTime: workoutDate.workout_time,
    }
  }
  function updateDisplayModal(value: boolean) {
    displayModal.value = value
  }
  function deleteWorkout(workoutId: string) {
    store.dispatch(WORKOUTS_STORE.ACTIONS.DELETE_WORKOUT, {
      workoutId: workoutId,
    })
  }

  watch(
    () => route.params.segmentId,
    async (newSegmentId) => {
      if (newSegmentId) {
        segmentId.value = +newSegmentId
      }
    }
  )

return (_ctx: any,_cache: any) => {
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(displayModal))
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          title: _ctx.$t('common.CONFIRMATION'),
          message: _ctx.$t('workouts.WORKOUT_DELETION_CONFIRMATION'),
          onConfirmAction: _cache[0] || (_cache[0] = ($event: any) => (deleteWorkout(_unref(workoutObject).workoutId))),
          onCancelAction: _cache[1] || (_cache[1] = ($event: any) => (updateDisplayModal(false)))
        }, null, 8, ["title", "message"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createVNode(WorkoutCardTitle, {
          sport: _unref(sport),
          workoutObject: _unref(workoutObject),
          onDisplayModal: _cache[2] || (_cache[2] = ($event: any) => (updateDisplayModal(true)))
        }, null, 8, ["sport", "workoutObject"])
      ]),
      content: _withCtx(() => [
        _createVNode(WorkoutMap, {
          workoutData: _unref(workoutData),
          markerCoordinates: _unref(markerCoordinates)
        }, null, 8, ["workoutData", "markerCoordinates"]),
        _createVNode(WorkoutData, {
          workoutObject: _unref(workoutObject),
          useImperialUnits: _unref(authUser).imperial_units
        }, null, 8, ["workoutObject", "useImperialUnits"])
      ]),
      _: 1
    })
  ]))
}
}

})